import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/brand/gyre-logo-full-pill.png'
import _imports_1 from '../../assets/jyranians/jyranian-sad.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-44e97324"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-test": "invite-restricted-page",
  class: "restricted-invite-page"
}
const _hoisted_2 = { class: "restricted-invite-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Gyre logo"
  })
], -1))
const _hoisted_4 = { class: "restricted-invites-message reason-container" }
const _hoisted_5 = { "data-test": "invite-restricted-message" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "admin-contact-details" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Please contact your inviter."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("hr", { class: "green-underline" }),
  /*#__PURE__*/_createElementVNode("div", { class: "btn-container" }, [
    /*#__PURE__*/_createElementVNode("a", {
      role: "button",
      class: "btn btn-lg btn-default",
      href: "https://gyreteams.com/"
    }, "Continue")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "invite restriction"
  })
], -1))

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Analytics } from "../../services/analytics/analytics";
import { InviteRestrictionReason } from "../../typings/enums/invite-restriction-reason";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'invites-restricted',
  setup(__props) {

const route = useRoute();

const reasonForRestriction = computed(() => {
  switch (route.params.reason) {
    case InviteRestrictionReason.NoAvailableLicences:
    case InviteRestrictionReason.InvitesRestricted:
    case InviteRestrictionReason.AssessDeadlineExpired:
    case InviteRestrictionReason.InviteExpired:
      return route.params.reason;
    default:
      return "no reason given";
  }
});

const errorTitle = computed(() => {
  switch (reasonForRestriction.value) {
    case InviteRestrictionReason.InviteExpired:
      return "Invite Expired ⌛";
    case InviteRestrictionReason.AssessDeadlineExpired:
      return "Review Submission Closed ⌛";
    case InviteRestrictionReason.NoAvailableLicences:
      return "Sorry, you can't currently join this subscription.";
    default:
      return "Sorry, you can't currently join this team.";
  }
});

function logAssessDeadlineExpiredEvent(): void {
  Analytics.action("Review deadline passed", "GyreAssessActions", {
    userId: csContext.user.id,
    userName: `${csContext.user.firstName} ${csContext.user.lastName}`,
    userEmail: csContext.user.email,
    organisationId: csContext.user.organisation.id,
    organisationName: csContext.user.organisation.name,
  });
}

onMounted(() => {
  if (reasonForRestriction.value === InviteRestrictionReason.AssessDeadlineExpired) {
    logAssessDeadlineExpiredEvent();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(errorTitle.value), 1),
        (reasonForRestriction.value === _unref(InviteRestrictionReason).InvitesRestricted)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_6, " Invites have been restricted "))
          : _createCommentVNode("", true),
        (reasonForRestriction.value === _unref(InviteRestrictionReason).NoAvailableLicences)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_7, " No available licences "))
          : _createCommentVNode("", true),
        (reasonForRestriction.value === _unref(InviteRestrictionReason).AssessDeadlineExpired)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, " The deadline for submitting your solo review has passed. "))
          : _createCommentVNode("", true),
        (reasonForRestriction.value === _unref(InviteRestrictionReason).InviteExpired)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_9, " This invite has expired. "))
          : _createCommentVNode("", true)
      ]),
      _hoisted_10,
      _hoisted_11
    ])
  ]))
}
}

})